import { SetState } from 'zustand';
import { TrainingQueryDetailsFragment } from 'generated/graphql';
import { UpdateTrainingQueryState } from 'stores/interfaces/UpdateQueryState';

export const createUpdateTrainingQuerySlice = (set: SetState<UpdateTrainingQueryState>) => ({
  setInitialStateWithProps: (queryDetails: TrainingQueryDetailsFragment) =>
    set({
      xtmProjectName: queryDetails.xtmProjectName,
      fileName: queryDetails.fileName
    })
});
